// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.simple-card-module__card___an5Jk {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: none;
  background-color: var(--surface1, #fff);
  padding: 16px;
  border-radius: 16px;
  box-shadow: 8px 8px 40px 0px rgba(20, 20, 20, 0.1019607843);
  text-align: start;
}
.simple-card-module__card--no-shadow___gSKfc {
  box-shadow: none;
}
.simple-card-module__card--outline___ag4uL {
  border: 1px solid var(--neutral30, #e3e6e8);
}`, "",{"version":3,"sources":["data:;charset=utf-8,/**%20function%20to%20get%20dimensions%0A%20%20usage%20example%20to%20get%20%60tablet%60%20value%20from%20%60$page-max-widths%60%0A%20%20.class%20%7B%0A%20%20%20%20max-width:%20dim($page-max-widths,%20tablet);%0A%20%20%7D%0A%0A%20*/%0A%0A@use%20'sass:map';%0A%0A@function%20dim($prop,%20$key)%20%7B%0A%20%20@return%20map.get($prop,%20$key);%0A%7D%0A","webpack://./client/app/react-components/simple-card/simple-card.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,YAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,2DAAA;EACA,iBAAA;AAMF;AAJE;EACE,gBAAA;AAMJ;AAHE;EACE,2CAAA;AAKJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `simple-card-module__card___an5Jk`,
	"card--no-shadow": `simple-card-module__card--no-shadow___gSKfc`,
	"card--outline": `simple-card-module__card--outline___ag4uL`
};
export default ___CSS_LOADER_EXPORT___;
